import { render, staticRenderFns } from "./hgVisits.vue?vue&type=template&id=2417cf64&scoped=true&"
import script from "./hgVisits.vue?vue&type=script&lang=js&"
export * from "./hgVisits.vue?vue&type=script&lang=js&"
import style0 from "./hgVisits.vue?vue&type=style&index=0&id=2417cf64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417cf64",
  null
  
)

export default component.exports